// extracted by mini-css-extract-plugin
export default {"rowActive":"DraggableRow__rowActive___VcRBU","lastRowActive":"DraggableRow__lastRowActive___QZZ1m"};